<form [formGroup]="filterFormGroup">
  <div class="flex-grow">
    <div class="filter-elements">

      <!-- NetzbetreiberID -->
      @if (isWetznetzUser) {
        <mat-form-field redispatchProvideReadonly>
          <mat-label>Netzbetreiber-ID</mat-label>
          <input matInput
            [matAutocomplete]="stadtwerkeId"
            data-qa="filter-netzbetreiber-stadtwerkeId"
            formControlName="stadtwerkeId">
          <mat-icon matSuffix svgIcon="innogy_picto_magnifier"></mat-icon>
          <mat-autocomplete #stadtwerkeId="matAutocomplete"
            panelWidth="200">
            @for (stadtwerkeId of filteredStadtwerkeId$ | async; track stadtwerkeId) {
              <mat-option
                [value]="stadtwerkeId"
                data-qa="filter-netzbetreiber-stadtwerkeId-option">
                {{stadtwerkeId}}
              </mat-option>
            }
          </mat-autocomplete>
        </mat-form-field>
      }

      <!-- Netzbetreibername -->
      @if (isWetznetzUser) {
        <mat-form-field redispatchProvideReadonly>
          <mat-label>Netzbetreiber-Name</mat-label>
          <input matInput
            [matAutocomplete]="netzbetreiberName"
            data-qa="filter-netzbetreiber-name"
            formControlName="netzbetreiberName">
          <mat-icon matSuffix svgIcon="innogy_picto_magnifier"></mat-icon>
          <mat-autocomplete #netzbetreiberName="matAutocomplete" panelWidth="200">
            @for (netzbetreiberName of filteredNetzbetreiber$ | async; track netzbetreiberName) {
              <mat-option
                [value]="netzbetreiberName"
                data-qa="filter-netzbetreiber-name-option">
                {{netzbetreiberName}}
              </mat-option>
            }
          </mat-autocomplete>
        </mat-form-field>
      }

      <!-- Netzbetreiberteilgebiet -->
      @if (isWetznetzUser) {
        <mat-form-field redispatchProvideReadonly>
          <mat-label>Teilgebiet</mat-label>
          <input matInput
            [matAutocomplete]="teilgebiet"
            data-qa="filter-netzbetreiber-teilgebiet"
            formControlName="teilgebiet">
          <mat-icon matSuffix svgIcon="innogy_picto_magnifier"></mat-icon>
          <mat-autocomplete #teilgebiet="matAutocomplete" panelWidth="200">
            @for (teilgebiet of filteredTeilgebiete$ | async; track teilgebiet) {
              <mat-option
                [value]="teilgebiet"
                data-qa="filter-netzbetreiber-teilgebiet-option">
                {{teilgebiet}}
              </mat-option>
            }
          </mat-autocomplete>
        </mat-form-field>
      }

      <!-- Netzgruppe -->
      <mat-form-field data-qa="kaskade-netzzuordnungen-filter">
        <mat-label>Netzgruppe</mat-label>
        <input matInput
          name="netzgruppe"
          [matAutocomplete]="netzgruppe"
          data-qa="filter-netzgruppe"
          formControlName="netzgruppe">
        <mat-icon matSuffix svgIcon="innogy_picto_magnifier"></mat-icon>

        <mat-autocomplete #netzgruppe="matAutocomplete" panelWidth="200">
          @for (netzgruppe of filteredNetzgruppe$ | async; track netzgruppe) {
            <mat-option [value]="netzgruppe">
              {{netzgruppe}}
            </mat-option>
          }
        </mat-autocomplete>
      </mat-form-field>


      <!-- Ortsname -->
      <mat-form-field redispatchProvideReadonly>
        <mat-label>Ortsname</mat-label>
        <input matInput
          name="ortsname"
          [matAutocomplete]="ortsname"
          data-qa="filter-ortsname"
          formControlName="ortsname">
        <mat-icon matSuffix svgIcon="innogy_picto_magnifier"></mat-icon>

        <mat-autocomplete #ortsname="matAutocomplete"
          panelWidth="200">
          @for (ortsname of filteredOrtsnamen$ | async; track ortsname) {
            <mat-option [value]="ortsname" data-qa="filter-ortsname-option">
              {{ortsname}}
            </mat-option>
          }
        </mat-autocomplete>
      </mat-form-field>

      <!-- Stationsname -->
      <mat-form-field redispatchProvideReadonly>
        <mat-label>Stationsname</mat-label>
        <input matInput
          name="stationsname"
          [matAutocomplete]="stationsname"
          data-qa="filter-stationsname"
          formControlName="stationsname">
        <mat-icon matSuffix svgIcon="innogy_picto_magnifier"></mat-icon>

        <mat-autocomplete #stationsname="matAutocomplete"
          panelWidth="200">
          @for (stationsname of filteredStationsnamen$ | async; track stationsname) {
            <mat-option [value]="stationsname" data-qa="filter-stationsname-option">
              {{stationsname}}
            </mat-option>
          }
        </mat-autocomplete>
      </mat-form-field>

      <!-- Trafo-, Feldname, SS -->
      <mat-form-field redispatchProvideReadonly>
        <mat-label>Trafo-, Feldname, SS</mat-label>
        <input matInput
          name="trafoFeldName"
          [matAutocomplete]="trafoFeldName"
          data-qa="filter-trafofeldname"
          formControlName="trafoFeldName">
        <mat-icon matSuffix svgIcon="innogy_picto_magnifier"></mat-icon>

        <mat-autocomplete #trafoFeldName="matAutocomplete"
          panelWidth="200">
          @for (trafoFeldName of filteredTrafoFeldNamen$ | async; track trafoFeldName) {
            <mat-option [value]="trafoFeldName" data-qa="filter-trafofeldname-option">
              {{trafoFeldName}}
            </mat-option>
          }
        </mat-autocomplete>
      </mat-form-field>

      <!-- UUID -->
      <mat-form-field redispatchProvideReadonly>
        <mat-label>UUID</mat-label>
        <input matInput
          name="uuid"
          [matAutocomplete]="uuid"
          data-qa="filter-uuid"
          formControlName="uuid">
        <mat-icon matSuffix svgIcon="innogy_picto_magnifier"></mat-icon>

        <mat-autocomplete #uuid="matAutocomplete"
          panelWidth="200">
          @for (uuid of filteredUuid$ | async; track uuid) {
            <mat-option [value]="uuid" data-qa="filter-uuid-option">
              {{uuid}}
            </mat-option>
          }
        </mat-autocomplete>
      </mat-form-field>

      <!-- Date -->
      <mat-form-field redispatchProvideReadonly data-qa="filter-uuidDatum">
        <mat-label>UUID-Datum</mat-label>
        <mat-date-range-input formGroupName="uuidDate" [rangePicker]="picker">
          <input matStartDate formControlName="start" placeholder="Start date">
          <input matEndDate formControlName="end" placeholder="End date">
        </mat-date-range-input>
        <mat-datepicker-toggle matSuffix [for]="picker">
          <mat-icon matDatepickerToggleIcon svgIcon="innogy_picto_calendar-date-year"></mat-icon>
        </mat-datepicker-toggle>
        <mat-date-range-picker #picker></mat-date-range-picker>
        <mat-icon matSuffix svgIcon="innogy_picto_magnifier"></mat-icon>
      </mat-form-field>

      <!-- Technischer Platz -->
      <mat-form-field redispatchProvideReadonly>
        <mat-label>Technischer Platz</mat-label>
        <input matInput
          name="technischerPlatz"
          [matAutocomplete]="technischerPlatz"
          data-qa="filter-technischerplatz"
          formControlName="technischerPlatz">
        <mat-icon matSuffix svgIcon="innogy_picto_magnifier"></mat-icon>

        <mat-autocomplete #technischerPlatz="matAutocomplete"
          panelWidth="200">
          @for (technischerPlatz of filteredTechnischerPlatz$ | async; track technischerPlatz) {
            <mat-option [value]="technischerPlatz" data-qa="filter-technischerplatz-option">
              {{technischerPlatz}}
            </mat-option>
          }
        </mat-autocomplete>
      </mat-form-field>


    </div>
  </div>

  <div class="reset-button-container">
    <button id="resetFiltersButton" matButton="filled" type="reset" data-qa="reset-filter-button">
        <mat-icon>autorenew</mat-icon>
        Zurücksetzen
    </button>
    <button id="exportCsvButton" matButton="outlined" type="button" data-qa="export-csv-button"
      (click)="exportNetzzuordnungen()">
        <mat-icon>file_download</mat-icon>
        CSV exportieren
    </button>
  </div>
</form>

